"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactAvatar = ContactAvatar;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _internal = require("./internal");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент аватарки
 * Размер зависит от контекста использования и не должен изменяться напрямую
 *
 * Люди - круглые аватарки
 * Компании - квадратные
 */
function ContactAvatar(_ref) {
  let {
    type,
    src
  } = _ref;
  const {
    size,
    highlight
  } = (0, _internal.useContactAvatarContext)();
  return /*#__PURE__*/React.createElement(_uiKit.Avatar, {
    type: type,
    src: src,
    size: size,
    highlight: highlight && 'white_100'
  });
}